export const PAYING_TIERS = ["essentials", "growth", "enterprise"];

/** Tiers shown on Customer Analytics (paying + demo prospects). */
export const ANALYTICS_TIERS = ["demo", "essentials", "growth", "enterprise"];

export const ALL_PLAN_TIERS = ["free", "demo", "essentials", "growth", "enterprise"];

export const PLAN_OPTIONS = [
  { value: "free", label: "Free" },
  { value: "demo", label: "Demo" },
  { value: "essentials", label: "Essentials" },
  { value: "growth", label: "Growth" },
  { value: "enterprise", label: "Enterprise" },
];

export const PLAN_DISPLAY = {
  free: "Free",
  demo: "Demo",
  essentials: "Essentials",
  growth: "Growth",
  enterprise: "Enterprise",
};

export const PLAN_STYLES = {
  free: "bg-surface-neutral-subtle text-text-secondary",
  demo: "bg-severity-medium/10 text-severity-medium",
  essentials: "bg-accent-green/10 text-accent-green",
  growth: "bg-accent-purple/10 text-accent-purple",
  enterprise: "bg-accent-pink/10 text-accent-pink",
};

const DISPLAY_PLAN_FALLBACK = {
  pro: "growth",
  trial: "growth",
  fast_track: "growth",
  premium: "growth",
};

export function displayPlan(plan) {
  const p = (plan || "free").toLowerCase();
  return DISPLAY_PLAN_FALLBACK[p] ?? p;
}
